import * as Yup from 'yup';

export interface OrgFormValues {
  name: string;
  shortName: string;
  internalCode: string;
  description: string;
  address: string;
  contactPerson: string;
  phone: string;
  email: string;
  status: 'active' | 'inactive';
  logo: File | null;
}

export const initialOrgValues: OrgFormValues = {
  name: '',
  shortName: '',
  internalCode: '',
  description: '',
  address: '',
  contactPerson: '',
  phone: '',
  email: '',
  status: 'active',
  logo: null,
};

// Validation is wired up but errors are intentionally not surfaced yet ("hide validations").
export const orgValidationSchema = Yup.object({
  name: Yup.string().required('Organization name is required'),
  shortName: Yup.string().required('Short name is required'),
  email: Yup.string().email('Enter a valid email address'),
});
